import japantrad1 from './japantrad1.jpg'
import japantrad2 from './japantrad2.png'
import japantrad3 from './japantrad3.png'
import japantrad4 from './japantrad4.png'
import japantrad5 from './japantrad5.png'
import japantrad6 from './japantrad6.png'
import japantrad7 from './japantrad7.png'
import japantrad8 from './japantrad8.png'
import japantrad9 from './japantrad9.png'
import japantrad10 from './japantrad10.png'
import japantrad11 from './japantrad11.png'

const japaneseTraditional = [
    japantrad1,
    japantrad2,
    japantrad3,
    japantrad4,
    japantrad5,
    japantrad6,
    japantrad7,
    japantrad8,
    japantrad9,
    japantrad10,
    japantrad11
]

export default japaneseTraditional;
